export const blockIconsHomeActivityZoneNew = (
	<span className='material-symbols-outlined'>activity_zone</span>
);
